import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrl: './qr.component.scss'
})
export class QrComponent {
  constructor(private activeModal: NgbModal) { }

  @Input() isModal: boolean;
  @Input() successButton: string;
  @Input() qrData: string;

  closeModal(): void {
    this.activeModal.dismissAll();
  }
}